import {DefaultSettings, settings} from '../../../settings/settings-util';
import reduceReducers from 'reduce-reducers';
import {AlmeState, defaultState} from "../../../wireup/AlmeState";
import {Reducer, Store} from "redux";
import {HistoryMessage, HistoryMessageNotification} from "../../../types/history";
import {VChild, VNode} from "virtual-dom";
import {Dictionary, Mutator} from "../../../types/rendering";
import h from "virtual-dom/h";

type ChildComponent = { getRenderer: () => ComponentRenderer; getReducer: () => Reducer<AlmeState> };
type ComponentRenderer = (message: HistoryMessage) => VNode;
type MutatorModule = { getMutator: () => Mutator };

export default class NotificationMessageRenderer
{
    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _mutatorModules: MutatorModule[];
    _childComponents: ChildComponent[];

    _mutators: Mutator[] = [];
    _childRenderers: ComponentRenderer[] = [];

    constructor(passedSettings?: DefaultSettings, mutatorModules: MutatorModule[] = [], childComponents: ChildComponent[] = [])
    {
        this._settings = passedSettings ?? settings;
        this._mutatorModules = mutatorModules;
        this._childComponents = childComponents;
    }

    static getDefaultSettings(): DefaultSettings
    {
        return settings;
    }

    initialize(store): void
    {
        this._mutators = this._mutatorModules.map(module => module.getMutator());
        this._childRenderers = this._childComponents.map(component => component.getRenderer());
        this._store = store;
    }

    getReducer(): Reducer<AlmeState>
    {
        const childComponentReducers = this._childComponents.map(component => component.getReducer());

        return reduceReducers(defaultState, ...childComponentReducers);
    }

    doesRender(message: HistoryMessage): boolean
    {
        return message.type === this._settings.messageConstants.notificationType;
    }

    getRenderer(): (message: HistoryMessage) => VChild
    {
        return (message: HistoryMessage): VChild =>
        {
            if(!this.doesRender(message)) return [];

            const { notificationMessageClassName } = this._settings.classNames;

            const childNodes = this._childRenderers.map(render => render(message));
            const textNode = h('div', { className: notificationMessageClassName }, (message as HistoryMessageNotification).text ?? "");

            return h('div', this.buildResponseProperties(), [...childNodes, textNode]);
        };
    }

    //#region Helper Methods

    buildResponseProperties(): Dictionary
    {
        const properties: Dictionary = { className: this._settings.classNames.notificationClassName };
        if (this._settings.accessibility?.focusable?.notificationMessage) { properties.tabIndex = 0; }

        return this._mutators.reduce((props, mutate) => mutate(props), properties);
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-notification/src/message-renderer-notification.ts